import React, { useMemo } from 'react';
import { Button as MUIButton, CircularProgress } from '@mui/material';

import { Props } from './props';

export const Button: React.FC<Props> = (props) => {
  const { variant = 'text', children, loading = false, ...restProps } = props;
  const rest = useMemo(() => {
    if (loading)
      return {
        ...restProps,
        startIcon: (
          <CircularProgress size={20} sx={{ color: 'rgba(0, 0, 0, 0.26)' }} />
        ),
      };
    return { ...restProps };
  }, [loading, restProps]);
  const renderButton = () => {
    switch (variant) {
      case 'outlined-primary':
        return (
          <MUIButton
            {...rest}
            disabled={loading}
            sx={{
              border: '2px solid',
              borderColor: 'primary',
            }}
          >
            {children}
          </MUIButton>
        );
      default:
        return (
          <MUIButton variant={variant} {...rest}>
            {children}
          </MUIButton>
        );
    }
  };
  return renderButton();
};
export type CustomButtonProps = Props;
export default Button;
